import { AxiosInstance } from 'axios';
import {
  SiteAnnouncement,
  SiteAnnouncementCreateDTO,
  SiteAnnouncementListDTO,
  SiteAnnouncementUpdateDTO
} from 'core/siteAnnouncement/SiteAnnouncement';
import client from './RestClient';

export interface SiteAnnouncementWebService {
  getSiteAnnouncement: (id: number) => Promise<SiteAnnouncement>;
  getSiteAnnouncements: () => Promise<SiteAnnouncementListDTO[]>;
  createSiteAnnouncement: (
    createDTO: SiteAnnouncementCreateDTO
  ) => Promise<void>;
  updateSiteAnnouncement: (
    updateDTO: SiteAnnouncementUpdateDTO
  ) => Promise<void>;
  getTopAnnouncement: (
    agencyId: number
  ) => Promise<SiteAnnouncement | undefined>;
  activateAnnouncements: (ids: number[]) => Promise<void>;
  deactivateAnnouncements: (ids: number[]) => Promise<void>;
  deleteAnnouncements: (ids: number[]) => Promise<void>;
}

export class RestfulSiteAnnouncementWebService implements SiteAnnouncementWebService {
  private restClient: AxiosInstance;

  constructor(restClient: AxiosInstance = client) {
    this.restClient = restClient;
  }

  async getSiteAnnouncement(id: number): Promise<SiteAnnouncement> {
    const response = await this.restClient.get(`/v2/site-announcements/${id}`);
    return response.data;
  }

  async getSiteAnnouncements(): Promise<SiteAnnouncementListDTO[]> {
    const response = await this.restClient.get('/v2/site-announcements');
    return response.data.records;
  }

  async createSiteAnnouncement(
    createDTO: SiteAnnouncementCreateDTO
  ): Promise<void> {
    await this.restClient.post('/v2/site-announcements', createDTO);
  }

  async updateSiteAnnouncement(
    updateDTO: SiteAnnouncementUpdateDTO
  ): Promise<void> {
    await this.restClient.put('/v2/site-announcements', updateDTO);
  }

  async getTopAnnouncement(
    agencyId: number
  ): Promise<SiteAnnouncement | undefined> {
    const response = await this.restClient.get(
      `/v2/site-announcements/top?agencyId=${agencyId}`
    );
    return response.data;
  }

  async activateAnnouncements(ids: number[]): Promise<void> {
    await this.restClient.put(
      `/v2/site-announcements/activate?ids=${ids.join(',')}`
    );
  }

  async deactivateAnnouncements(ids: number[]): Promise<void> {
    await this.restClient.put(
      `/v2/site-announcements/deactivate?ids=${ids.join(',')}`
    );
  }

  async deleteAnnouncements(ids: number[]): Promise<void> {
    await this.restClient.delete(`/v2/site-announcements?ids=${ids.join(',')}`);
  }
}
